import React from 'react';
import { Card, CardContent, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import FormIcon from '../CustomSVGIcons/FormIcon';
import IconPopoverMenu from '../IconPopoverMenu/IconPopoverMenu';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';

type FormCardProps = {
    title: string;
    onEdit: () => void;
    onDelete: () => void;
    onDuplicate: () => void;
};

const FormCard: React.FC<FormCardProps> = ({ title, onEdit, onDelete, onDuplicate }) => {
    const { themeStyle } = useThemeContext();
    const handleMenuAction = (action: 'edit' | 'delete' | 'duplicate') => {
        switch (action) {
            case 'delete':
                onDelete && onDelete();
                break;
            case 'duplicate':
                onDuplicate && onDuplicate();
                break;
            case 'edit':
                onEdit && onEdit();
                break;
        }
    };

    return (
        <Card
            variant="outlined"
            sx={{
                display: 'flex',
                alignItems: 'center',
                p: 2,
                maxWidth: '100%',
                borderRadius: 2,
                position: 'relative',
            }}>
            <CardContent>
                <FormIcon />
            </CardContent>
            <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
                <IconPopoverMenu
                    icon={<EditIcon stroke={theme[themeStyle].tag_white} height={'24px'} width={'24px'} />}
                    onOptionClick={handleMenuAction}
                    iconButtonStyle={{ color: 'gray' }}
                />
            </Box>
        </Card>
    );
};

export default FormCard;
